/* @flow */
import * as React from 'react';
import styled from 'styled-components';

import { Icon } from '@sonyged/proc-ui';
import { css } from '@styled-system/css';

export const LossColor = '#d57d9a';

type Props = {
  forNum: number,
};
export const ArrowIcon = function(props: Props) {
  let { forNum } = props;
  let head;
  if (forNum > 0) head = 'up';
  if (forNum < 0) head = 'down';
  if (!head) return null;
  return <ArrowIconReal head={head} />;
};

const ArrowIconReal = styled(Icon).attrs(({ head }) => ({ variant: `arrow-${head}` }))(({ head }) =>
  css({
    position: 'relative',
    top: '0.14em', // there is space bellow the icon
    '&&::before': {
      color: head === 'up' ? 'gray100' : LossColor,
    },
  })
);
